import { create } from 'zustand';

import { GenericDialog } from '../types/GenericDialog';

interface GlobalComponentsStore {
  // Loading Start
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
  // Loading End

  // Dialog Start
  pendingActionDialogs: GenericDialog[];
  setPendingActionDialogs: (genericDialogs: GenericDialog[]) => void;
  getPendingActionDialogs: () => GenericDialog[];
  pushDialog: (genericDialog: GenericDialog) => void;
  popDialog: () => void;
  clearDialogs: () => void;
  // Dialog End
}

const useGlobalComponentsStore = create<GlobalComponentsStore>((set, get) => ({
  isLoading: false,
  setLoading: (isLoading: boolean) => {
    set({ isLoading: isLoading });
  },

  pendingActionDialogs: [],
  setPendingActionDialogs: (genericDialogs: GenericDialog[]) => {
    set({ pendingActionDialogs: [...genericDialogs] });
  },
  getPendingActionDialogs: () => get().pendingActionDialogs,
  pushDialog: (genericDialog: GenericDialog) => {
    const { pendingActionDialogs } = get();
    pendingActionDialogs.unshift(genericDialog);
    set({ pendingActionDialogs: [...pendingActionDialogs] });
  },
  popDialog: () => {
    const { pendingActionDialogs } = get();
    pendingActionDialogs.shift();
    set({ pendingActionDialogs: [...pendingActionDialogs] });
  },
  clearDialogs: () => {
    set({ pendingActionDialogs: [] });
  },
}));

export default useGlobalComponentsStore;
